(function () {
  function getLimits(input) {
    const min = parseInt(input.getAttribute('min'), 10);
    const max = input.dataset.max ? parseInt(input.dataset.max, 10) : NaN;
    return {
      min: Number.isFinite(min) ? min : 1,
      max: Number.isFinite(max) ? max : NaN,
      value: parseInt(input.value, 10)
    };
  }

  function clamp(input) {
    const { min, max } = getLimits(input);
    let val = parseInt(input.value, 10);
    if (!Number.isFinite(val)) val = min;
    if (val < min) val = min;
    if (!Number.isNaN(max) && val > max) val = max;
    input.value = val;
  }

  // 1) Klicks auf +/- VOR Impulse abfangen (Capture!)
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.js-qty__adjust');
      if (!btn) return;

      const wrapper = btn.closest('.js-qty__wrapper');
      if (!wrapper) return;

      const input = wrapper.querySelector('.js-qty__num');
      if (!input) return;

      // erst mal stabilisieren, falls jemand "9999" reingetippt hat
      clamp(input);

      const { min, max, value } = getLimits(input);
      const isPlus = btn.classList.contains('js-qty__adjust--plus');
      const isMinus = btn.classList.contains('js-qty__adjust--minus');

      // Wenn Limit erreicht: Impulse-Handler NICHT ausführen lassen
      if (isPlus && !Number.isNaN(max) && value >= max) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      if (isMinus && value <= min) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      // ansonsten: nichts tun -> Impulse darf normal weiterlaufen
    },
    true // <-- Capture-Phase, damit wir VOR Impulse dran sind
  );

  // 2) Manuelles Tippen begrenzen (Input + Change)
  document.addEventListener('input', function (e) {
    const input = e.target.closest('.js-qty__num');
    if (!input) return;
    // Nicht zu aggressiv clampen während des Tippens? Doch, hier clampen wir,
    // damit keine überhöhten Werte bleiben.
    clamp(input);
  });

  document.addEventListener('change', function (e) {
    const input = e.target.closest('.js-qty__num');
    if (!input) return;
    clamp(input);
  });
})();